import { FC, useCallback, useState } from 'react';
import React from 'react';

import { Box, Header } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { GeolocationDeniedModal } from 'components/geolocation-denied-modal';
import { StaticImage, StaticImages } from 'components/picture/static-image';
import { useGeolocation } from 'state/geolocation';
import { primitive } from 'styles/constants';
import { isNative } from 'utils/environment';
import { routes } from 'utils/routing';

import { useLoyaltyWalmart } from '../use-loyalty-walmart';
import { WalmartLogo } from '../walmart-logo';

import {
  GeneralBottomContainer,
  GeneralTopContainer,
  InnerBottomContainer,
  InnerGrayContainer,
  InnerWhiteContainer,
  LeftButtonOne,
  LeftButtonThree,
  LeftButtonTwo,
  RightButton,
  WalmartLogoContainer,
} from './styled';

export const WalmartLocation: FC<React.PropsWithChildren<{}>> = () => {
  const { isPermissionPrompt, isPermissionDenied, setPermissionChecking } = useGeolocation();
  const [geolocationDeniedModalOpen, setGeolocationDeniedModalOpen] = useState(false);
  const dismissModal = () => setGeolocationDeniedModalOpen(false);
  const { data, loading } = useLoyaltyWalmart();
  const router = useRouter();

  const handleGeolocationPrompt = useCallback(() => {
    if (isPermissionDenied) {
      setGeolocationDeniedModalOpen(true);
    } else if (isPermissionPrompt) {
      setPermissionChecking();
    }
    router.replace(`${routes.loyaltyOfferList}?success=true`);
  }, [router, isPermissionDenied, isPermissionPrompt, setPermissionChecking]);

  if (loading) {
    return null;
  }

  return (
    <>
      <View style={{ flex: 1, backgroundColor: primitive.$white }}>
        <Box
          height={{ md: '450px', base: isNative ? '470px' : '435px' }}
          background={primitive.$white}
        >
          <GeneralTopContainer isNative={isNative}>
            <Box>
              <LeftButtonOne />
              <LeftButtonTwo />
              <LeftButtonThree />
            </Box>
            <InnerWhiteContainer>
              <InnerGrayContainer>
                <StaticImage
                  borderTopLeftRadius={30}
                  borderTopRightRadius={30}
                  height={385}
                  width="full"
                  source={StaticImages.WalmartLocation}
                  alt={'BK Image'}
                ></StaticImage>
                <WalmartLogoContainer>
                  <WalmartLogo image={data?.logo?.locale} />
                </WalmartLogoContainer>
              </InnerGrayContainer>
            </InnerWhiteContainer>
            <RightButton />
          </GeneralTopContainer>
        </Box>
        <Box height={{ base: isNative ? '405px' : 'auto' }} background={primitive.$white}>
          <GeneralBottomContainer isNative={isNative}>
            <InnerBottomContainer>
              <Header textAlign="center">{data?.location?.title}</Header>
              <Typography textAlign="center" mb="$8">
                {data?.location?.description}
              </Typography>
              <ActionButton onPress={handleGeolocationPrompt} _text={{ fontSize: 'md' }} mb="$4">
                {data?.location?.shareLocationButton?.buttonText?.locale}
              </ActionButton>
              <ActionButton
                variant={ActionButtonVariants.TEXT_ONLY}
                onPress={() => router.replace(`${routes.loyaltyOfferList}?success=true`)}
              >
                {data?.location?.notShareLocationButton?.buttonText?.locale}
              </ActionButton>
            </InnerBottomContainer>
          </GeneralBottomContainer>
        </Box>
      </View>
      <GeolocationDeniedModal isOpen={geolocationDeniedModalOpen} dismissModal={dismissModal} />
    </>
  );
};
